/* eslint-disable @khan/frontend/require-stories -- covered by dismissible.stories.tsx */
import {useCallback, useEffect, useState} from "react";

import {type Props} from "./props.ts";
import {useDismissible} from "./use-dismissible.ts";

export default function ShowOnceDismissible({
    dismissKey,
    expiresDays,
    children,
    renderIfDismissed,
}: Omit<Props, "showOnce">): React.ReactElement {
    const {isDismissedResult, dismiss} = useDismissible(dismissKey);
    const [shouldShow, setShouldShow] = useState(false);

    useEffect(() => {
        if (isDismissedResult.status === "success" && !isDismissedResult.data) {
            dismiss(expiresDays);
            setShouldShow(true);
        }
    }, [dismiss, expiresDays, isDismissedResult]);

    const handleDismiss = useCallback(() => setShouldShow(false), []);

    return <>{shouldShow ? children(handleDismiss) : renderIfDismissed?.()}</>;
}
